export default "__VITE_ASSET__f0724828__"